import { useState } from "react";
import { Button } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import ApiService from "../../../modules/APIService.interceptors";
import { useNotifier } from "../../../hooks/useNotifier";
import EditPhoneNumberDialog from "./EditPhoneNumberDialog";

const EditPhoneNumberButton = ({ userId, setPhone }) => {
  const notify = useNotifier();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => { setOpen(true); };

  const handleClose = () => {
    if (!loading) setOpen(false);
  };

  const handleSave = async (composedE164) => {
    if (!userId) return;
    try {
      setLoading(true);
      await ApiService.updateUser(userId, {
        phone: composedE164,
        phone_verified: false,
      });
      setPhone(composedE164);
      setOpen(false);
      notify("Número actualizado (sin verificar)", "success");
    } catch (e) {
      if (e?.response?.data?.code === "PHONE_ALREADY_EXISTS") {
        notify("El número ya está en uso por otro usuario.", "error");
      } else {
        notify("Error al actualizar el teléfono.", "error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={handleOpen}
        disabled={!userId}
        startIcon={<EditIcon />}
      >
        Editar número
      </Button>

      <EditPhoneNumberDialog
        open={open}
        onClose={handleClose}
        onSave={handleSave}
        loading={loading}
      />
    </>
  );
};

export default EditPhoneNumberButton;
